export function getCssRulesLength(sheet) {
  var rule = ('insertRule' in sheet) ? sheet.cssRules : sheet.rules;
  return rule.length;
}


//////////////////
// WEBPACK FOOTER
// /Users/nickgehring/code/ymprealestate/wp-content/themes/ymprealestate/node_modules/tiny-slider/src/helpers/getCssRulesLength.js
// module id = 30
// module chunks = 0